import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { dropTask } from 'ember-concurrency';
import type FlashMessagesService from 'garaje/services/flash-messages';
import { MSTEAMS_V2_PLUGIN_KEY, SLACK_V2_PLUGIN_KEY } from 'garaje/utils/enums';

import { type LocationOverviewVirtualFrontDeskSettingsModel } from './route';

function platformKey(platformName: string): string {
  switch (platformName) {
    case 'msteams':
      return MSTEAMS_V2_PLUGIN_KEY;
    case 'slack':
      return SLACK_V2_PLUGIN_KEY;
    default:
      return platformName;
  }
}

export default class LocationOverviewVirtualFrontDeskSettingsController extends Controller {
  declare model: LocationOverviewVirtualFrontDeskSettingsModel;

  @service declare flashMessages: FlashMessagesService;

  get doesNotHaveSlackIntegration(): boolean {
    return !this.model.plugins.find((plugin) => plugin.key === SLACK_V2_PLUGIN_KEY);
  }

  get doesNotHaveTeamsIntegration(): boolean {
    return !this.model.plugins.find((plugin) => plugin.key === MSTEAMS_V2_PLUGIN_KEY);
  }

  @action
  isEnabled(platformName: string): boolean {
    const key = platformKey(platformName);
    const notificationPreference = this.model.notificationPreferences.find(
      (pref) => pref.notificationPlatformKey === key
    );
    return notificationPreference?.preferenceValue ?? false;
  }

  updatePreference = dropTask(async (platformName: string) => {
    const key = platformKey(platformName);
    const notificationPreference = this.model.notificationPreferences.find(
      (pref) => pref.notificationPlatformKey === key
    );
    if (!notificationPreference) return;
    notificationPreference.preferenceValue = !notificationPreference.preferenceValue;
    try {
      await notificationPreference.save();
    } catch {
      this.flashMessages.showAndHideFlash('error', 'Something went wrong', 'Please try again.');
      notificationPreference.rollbackAttributes();
    }
  });
}
